// @ts-nocheck
import { FC, ReactNode, useContext, useRef, useState } from "react";
import { Payload } from "../@types/common";
import { translation as t } from "../utils/translation";
import { ReactComponent as CirclePhone } from "../assets/icons/circle-phone.svg";
import { ReactComponent as CircleMail } from "../assets/icons/circle-mail.svg";
import { APIContext } from "../context/context";

interface ContactUsItemProps {
  children: ReactNode;
  text: string;
  params?: Payload;
}

interface ContactUsUrlItemProps extends ContactUsItemProps {
  url: string;
}

interface ContactUsFormItemProps extends ContactUsItemProps {
  lightningUrl: string;
}

const ContactUsFormItem = ({ text, params, lightningUrl, children }: ContactUsFormItemProps) => {
  // if form exist
  const [isCreated, setIsCreated] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  
  const openWebview = () => {
    console.log('open')
    $Lightning.use('c:mortgageForms_Wrapper', function () {
      $Lightning.createComponent('c:lex_mortgage_forms', {          
          leadSubSource: '62-24',
      },
      'compContainer',
      function (cmp) {
          console.log('LWC component was created');
          setIsShown(true);
      });
    },
    lightningUrl);
  
  };

  return (
    <div className="text-center w-full">
      <button className="mb-5"
        onClick={() => {
          if(!isCreated){
            setIsCreated(true);
            openWebview();
          }
          
          !isShown ? setIsShown(true) : setIsShown(false);

          window.dataLayer.push({
            Category: "Mortgage Calculator",
            Action: "Click",
            Label: text,
            event: "auto_event",
            ...params,
          });

          setTimeout(() => {
            ref.current?.scrollIntoView({ behavior: "smooth" });
          }, 100);

        }}
      >
        {children}
        {text}
      </button>
      <div id="compContainer" className={isShown ? 'block' : 'hidden'}></div>
    </div>
  );
};

const ContactUsUrlItem = ({ children, text, url, params }: ContactUsUrlItemProps) => {
  return (
    <a
      className="text-[18px]"
      href={url}
      target="_blank"
      onClick={() =>
        window.dataLayer.push({
          Category: "Mortgage Calculator",
          Action: "Click",
          Label: text,
          event: "auto_event",
          ...params,
        })
      }
    >
      {children}
      {text}
    </a>
  );
};


interface Props {
  params: Payload;
}
const ContactUs: FC<Props> = ({ params }) => {
  const API_AND_URLS = useContext(APIContext);

  const lightningUrl =
    API_AND_URLS !== undefined ? API_AND_URLS.URLS.TALK_WITH_US.LIGHTNING : "";
    
  // const urlWriteToUs =
  //   API_AND_URLS !== undefined ? API_AND_URLS.URLS.WRITE_TO_US : "";
  
  return (
    <div id="contactUs" className="flex w-full justify-center">
      {/* <div className="xxl:ml-7 xs:ml-5"> */}
        <ContactUsFormItem
          text={t.TALK_WITH_US}
          params={params}
          lightningUrl={lightningUrl}
        >
          <CirclePhone className="inline pl-2" />
        </ContactUsFormItem>
      {/* </div> */}
      {/* for next version */}
      {/* <div className="xxl:ml-7 xs:ml-5">
        <ContactUsUrlItem text={t.WRITE_TO_US} url={urlWriteToUs} params={params}>
          <CircleMail className="inline pl-2" />
        </ContactUsUrlItem>
      </div> */}
    </div>
  );
};
export default ContactUs;